import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from "react-redux";
import { SubmissionError } from 'redux-form';
import Dashboard from './../components/Menu/Dashboard'
import PropTypes from 'prop-types';
import { getCustomerData } from "./../actions/balances";
import { getUserData } from "./../actions/user";
import { addBeneficiary, getBeneficiaries } from "./../actions/beneficiary";
import { sendRequest, getQRPayment, sendPayment } from "./../actions/transactions";
import DialogOptions from '../components/Complements/DialogOptions';
import DialogImage from '../components/Complements/DialogImage';
import PaymenForm from '../components/Payments/PaymenForm';
import BeneficiaryList from '../components/Complements/BeneficiaryList';
import BeneficiaryFormDialog from '../components/Complements/DefaultUserForm';
// import DialogOTPRequest from '../components/Complements/DialogOTPRequest';
// import sendRequest from '../components/Complements/sendRequest';


class PaymentsContainer extends Component {
    // para obtener la data del customer buscado
    constructor(props) {
      super(props);
      this.state = { owner: '', cedule: '',  alert: false, email: '', form: {}, alertQR: false, img: '',
      message: '',
      type: '',
      openBeneficiaryForm: false,
      openDialogBeneficiaryList: false,
      beneficiaries: [],
      beneficiarySelected: {},
      beneficiaryFormData: {
        number: '',
        cedule: '',
        name: '',
        email: '',
        entity: '',
        beneficiary: 'INTERNO',
        type: '',
        Customers: {}
      },
      dataPayment: {
          cedule: '',
          name: '',
          email: '',
          entity: '',
          number: ''
      }};
      // this.handleClick = this.handleClick.bind(this);
    }
    clearForm = () => {
        this.setState(
            {beneficiaryFormData: {
                number: '',
                cedule: '',
                name: '',
                email: '',
                // entity: '',
                // beneficiary: 'INTERNO',
                type: '',
                Customers: {}
              }}
        )
    }
    handleSubmit = (values) => {
        // console.log(values)
        const { serie, imei, cedule} = this.props.device
        const { customers } = this.props

        this.props.sendPayment('PAY', serie, imei, values.cedule, values.amount, customers[0].email,
        cedule, 'PAGOS', values.description, 'true', '').then( r=> {
            // console.log(r.payload)
            const { data, result } = r.payload
            if (r.payload) {
                if (data) {
                    this.props.handleOpenSnack(result, 'success')
                    this.props.getUserData(cedule, 'cedule')
                    this.props.history.push('/')
                } else {
                    this.props.handleOpenSnack(result, 'error')
                }
            }
        })
        // this.setState({alertQR: false})
        // this.setState({ alert: true, form: values })
    }

    handleSubmitBeneficiary = (value) => {
        // console.log(value)
    }
    handlePayType = (option) => {
        // console.log('handlePayType', option)
        const { serie, imei} = this.props.device
        if (option === 'cobrar') {
            return this.props.sendRequest(this.props.device.serie, this.props.device.imei, this.state.form.cedule,
                this.state.form.amount, this.state.email, this.props.device.cedule,
                'COBROS', this.state.form.description).then(r => {
                    if (r.payload.State === 'v') {
                        this.props.history.push('/charges-tray')
                        this.props.handleOpenSnack('Solicitud realizada', 'success')
                    }
                })
        } else if (option === 'QR') {
            return this.props.getQRPayment(serie, imei, this.state.form.cedule,
                this.state.form.amount, this.props.device.cedule, 'USERCOBRO', this.state.form.description)
                .then(({payload})=> {
                    this.setState({alert: false})
                    this.setState({ alertQR: true, img: payload.qr })
                   //  console.log('la solicitud del qr es ', this.state)
                    // this.renderAlertQR(true, payload.qr)
                })
        }
        
        
    }
    setDataCustomerInServer = (value) => {
        this.props.getCustomerData(value, 'cedule').then(r => {
            // console.log('mi respuesta  ', r)
            if (r.error) {
                throw new SubmissionError(r.payload)
            }
            if (r.payload !== undefined ) {
                const {Customers} = r.payload
               
                const { first_name, second_name, surname, second_surname, cedule, email } = Customers
                let Names = `${first_name} ${second_name} ${surname} ${second_surname}`
                this.setState({ owner: Names, cedule, email })
            } else {
                this.setState({owner: '', cedule: '', email: ''})
                this.props.handleOpenSnack('Usuario no encontrado.', 'info')
            }
        })
    }
    findCustomer = (value) => {
        const { customers } = this.props
        if (customers.length === 0) {
            this.setDataCustomerInServer(value)
        } else {
            const getCustomer = customers.find(customer => customer.cedule === value);
            if (getCustomer === undefined) {
                this.setDataCustomerInServer(value)
            } else {
                const { first_name, second_name, surname, second_surname, cedule, email } = getCustomer.Customers
                let Names = `${first_name} ${second_name} ${surname} ${second_surname}`
                this.setState({ owner: Names, cedule, email })
            }            
        }
        // return customer
    }
    handleOnClick = () => {
        this.props.history.push('/customers')
    }
    handleOnSubmitSuccess = () => {
        //this.props.history.goBack()
    }

    renderAlert = (open) => {        
        if (open) {
            return <DialogOptions title = 'Tipo de pago' subTitle = '' handlePayType = { this.handlePayType } />
        } else {
            return <div></div>
        }
    }

    renderAlertQR = (OpenQR, img) => {
        // console.log('entra al render de qr', OpenQR, img)
        if (OpenQR) {
            // console.log('deberia abrir y retornar')
            return <DialogImage title = 'Escanee el codigo' subTitle = ''
            image = {img}/>
        } else {
            return <div></div>
        }       
    }

    handleOpenFormDialog = () => {
        this.setState({openBeneficiaryForm: true})
        // console.log('la verdad no', this.state.openBeneficiaryForm)
    }
    handleOpenBeneficiaryList = () => {
        
        this.props.getBeneficiaries(this.props.user.vusk).then(r => {
            // console.log('los beneficiarios ', r.payload, this.props.user)
            if (r.payload) {
                if (r.payload.length > 0) {
                    this.setState({beneficiaries: r.payload, openDialogBeneficiaryList: true})
                } else {
                    this.props.handleOpenSnack('No existen Beneficiarios', 'info')
                }
            }
        })
        
        // console.log('la verdad lista ', this.state.openDialogBeneficiaryList)
    }
    onAcceptClick = (values) => {
        // console.log(values, this.props.user)
        const { user } = this.props
        let dataSend = {
            owner:user.vusk,
            type: 'AHORROS',
            name: values.name,
            number: values.number,
            email: values.email,
            beneficiary: values.beneficiary,
            cedule: values.cedule,    
        }
        if (values.entity) {
            // console.log('sin entidad')
        } else {
            dataSend.entity = 'LOCAL'
            this.props.addBeneficiary(dataSend).then(r => {
                if (r.payload) {
                    this.props.handleOpenSnack('Beneficiario agregado', 'success')
                    this.setState({openBeneficiaryForm: false})
                }
            }).catch( err => {
                this.props.handleOpenSnack('El beneficiario no pudo ser agregado', 'error')
            })
        }
    }
    handleCloseDialogPayment = () => {
      this.setState({ openBeneficiaryForm: false });
    };

    handleCloseBeneficiaryList = () => {
      this.setState({ openDialogBeneficiaryList: false });
    };

    handleGetBeneficiarySelected = (values) => {
      this.setState({cedule: values.cedule, owner: values.name, openDialogBeneficiaryList: false})
      // console.log('se a seleccionado ', this.state.dataPayment)
    };
    handleGetAccount = (id) => {
        this.props.getCustomerData(id, 'number').then(r => {
            // console.log('encuentra esto ', r.payload)
            if(r.payload.message){
                this.props.handleOpenSnack('La cuenta no existe ', 'error')
            } else {
                this.setState({beneficiaryFormData: r.payload })
            }
        }).catch(error => {
            //console.log('el error ', error)
            this.props.handleOpenSnack('La cuenta no existe ', 'error')
        })
    }
    handleSetEntity = (entity) => {
        this.setState({beneficiaryFormData: {entity}})
    }

    handleOnCancel = () => {
        this.props.history.push('/')
    }

    renderBeneficiaryList = () => {
        return <BeneficiaryList
                    {...this.state}
                    getBeneficiarySelected = { this.handleGetBeneficiarySelected }
                    onCloseDialogBeneficiaryList = {this.handleCloseBeneficiaryList}/>
    }

    renderBeneficiaryForm = () => {
        return  <BeneficiaryFormDialog
                    {...this.state}
                    clearForm = { this.clearForm }
                    setEntity = { this.handleSetEntity }
                    findAccountUser = { this.handleGetAccount }
                    onAcceptClick = { this.onAcceptClick }
                    onCloseBeneficiaryForm ={this.handleCloseDialogPayment}/>
    }

    renderBody = () => {    
        // const { owner, cedule, alert, alertQR, img } = this.state   
        const { owner, cedule, alertQR, img } = this.state   
        return  <div>
                    <PaymenForm
                        classes = { this.props }
                        onSubmit = { this.handleSubmit }
                        onCancel = { this.handleOnCancel }
                        findCustomer = { this.findCustomer}
                        owner = { owner }
                        cedule = { cedule }
                        // alert = { this.renderAlert(alert) }
                        QR = { this.renderAlertQR(alertQR, img) }
                        // onSubmitSuccess = { this.handleOnSubmitSuccess }
                        openFormDialog = { this.handleOpenFormDialog }
                        openBeneficiaryList = { this.handleOpenBeneficiaryList }
                        beneficiaryForm = { this.renderBeneficiaryForm() }
                        beneficiaryList = { this.renderBeneficiaryList() }
                        />
                </div>
    }

    render() {
        return (
            <div>
                <Dashboard
                    title= "Pagos"
                    body = { this.renderBody() }
                    // info = { this.renderInfoBody() }
                    // chart = { this.renderChart() }
                    multiple = { false }
                />
            </div>
        );
    }
}

PaymentsContainer.propTypes = {
    user: PropTypes.object,
}

const mapState = (state) => {
    const customers = state.customers;
    const {user} = state.authentication;
    const device = state.devices
    return { customers, device, user };
}

export default withRouter(connect(mapState, {
    getCustomerData,
    sendRequest,
    getQRPayment,
    sendPayment,
    addBeneficiary,
    getBeneficiaries,
    getUserData } )(PaymentsContainer));
// export default withRouter(PaymentsContainer);